import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { ToastController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private isConnectedSubject = new BehaviorSubject<boolean>(true);
  isConnected$ = this.isConnectedSubject.asObservable(); // ✅ for async pipe
  isConnected = true; // optional for quick access in TS

  constructor() {
    this.initializeNetworkListener();
  }

  async initializeNetworkListener() {
    const status = await Network.getStatus();
    this.updateStatus(status.connected);

    Network.addListener('networkStatusChange', (status) => {
      this.updateStatus(status.connected);
    });
  }

  private updateStatus(connected: boolean) {
    this.isConnected = connected;
    this.isConnectedSubject.next(connected);
  }

  async isOnline(): Promise<boolean> {
    const status = await Network.getStatus();
    return status.connected;
  }
}
